import './Footer.scss'

import {FooterContact, FooterContactType} from './FooterContact'
import {Social, SocialLinkType} from '../Social'

import {FooterDonorinfoLogo} from './FooterDonorinfoLogo'
import {FooterEfLogo} from './FooterEfLogo'
import {LinkType} from '../../../types'
import {Logo} from '../../ui/Logo'
import {Navlinks} from '../Navlinks'
import React from 'react'
import {Theme} from '../../Theme'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('footer', ['navigation', 'nav', 'subnav'])

export type FooterType = FooterNavigationType &
	FooterContactType & {
		nav_use: boolean
		nav_links?: Array<LinkType>
		subnavigation?: Array<LinkType>
		subnav_use: boolean
		subnav_links?: Array<LinkType>
		social_text?: string
		social_links?: Array<SocialLinkType>
	}

type FooterNavigationType = {
	navigation?: Array<LinkType>
	btn?: LinkType
}

export const Footer: React.FC<FooterType> = ({
	address,
	phone,
	email,
	iban,
	navigation,
	btn,
	nav_use = true,
	nav_links,
	subnavigation,
	subnav_use = true,
	subnav_links,
	social_text,
	social_links
}) => {
	const t = useTranslation('footer')

	return (
		<footer className={styles()}>
			<Theme.Container>
				<span className={styles('line')} />
				<div className={styles('row')}>
					<div className={styles('row-col')}>
						<Logo />
						<FooterContact
							address={address}
							phone={phone}
							email={email}
							iban={iban}
						/>
					</div>
					{navigation && navigation.length > 0 && (
						<div className={styles('row-col')}>
							{nav_use && (
								<FooterNavigation navigation={navigation} btn={btn} />
							)}
							{!nav_use && <Navlinks styles={styles.nav} links={nav_links} />}
						</div>
					)}
					{subnavigation && subnavigation.length > 0 && (
						<div
							className={styles('row-col').mod({
								row: subnavigation?.length > 5
							})}
						>
							{subnav_use && (
								<Navlinks styles={styles.subnav} links={subnavigation} />
							)}
							{!subnav_use && (
								<Navlinks styles={styles.subnav} links={subnav_links} />
							)}
						</div>
					)}
				</div>
				<div className={styles('bottom')}>
					<div className={styles('bottom-logos')}>
						<FooterDonorinfoLogo />
						<FooterEfLogo />
					</div>
					<Social
						text={social_text}
						links={social_links}
						className={styles('bottom-social')}
					/>
				</div>
			</Theme.Container>
		</footer>
	)
}

const FooterNavigation: React.FC<FooterNavigationType> = ({
	navigation,
	btn
}) => {
	if ((!navigation || navigation.length === 0) && !btn) return null

	return (
		<div className={styles.navigation()}>
			<Navlinks styles={styles.nav} links={navigation} />
			<div className={styles.navigation('buttons')}>
				{btn && btn?.url && (
					<div className={styles.navigation('buttons-item')}>
						<Theme.Button to={btn.url} withIcon="arrow">
							{btn.description || btn.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</div>
	)
}
